export const makeAutoSummary = (payload: {
  researchGoal: string;
  additionalQuestions: string;
}): string => `# Summary
      
This is a temporarily mocked **summary** for the research goal _"${payload.researchGoal}"_.

## Questions

${payload.additionalQuestions}`;
